import WarehouseStore from './WarehouseStore'

export default WarehouseStore
